import { render, staticRenderFns } from "./LineSetting.vue?vue&type=template&id=60254088&scoped=true"
import script from "./LineSetting.vue?vue&type=script&lang=js"
export * from "./LineSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60254088",
  null
  
)

export default component.exports